import React from 'react';
import { Icon, Tooltip } from 'antd';
import { sortParams } from '../../../../../constants/common';
import styles from './SortDone.module.scss';

const getColorStyle = (isActive) => ({
  color: isActive ? '#0995ed' : '#afafaf',
});

const SortDone = ({ onSort, sortConfig }) => {
  return (
    <>
      <Tooltip
        mouseLeaveDelay={0}
        title="по просроченным дням"
      >
        <Icon
          className={styles.icon}
          style={getColorStyle(sortConfig?.param === sortParams.EXPIRED)}
          onClick={(e) => {
            e.stopPropagation();
            onSort({ key: 'done', param: sortParams.EXPIRED });
          }}
          type="fire"
          theme="outlined"
        />
      </Tooltip>

      <Tooltip
        mouseLeaveDelay={0}
        title="по дате выполнения"
      >
        <Icon
          className={styles.icon}
          style={getColorStyle(sortConfig?.param === sortParams.CLOSED)}
          onClick={(e) => {
            e.stopPropagation();
            onSort({ key: 'done', param: sortParams.CLOSED });
          }}
          type="check-square"
          theme="outlined"
        />
      </Tooltip>

      <Tooltip
        mouseLeaveDelay={0}
        title="по дате закрытия"
      >
        <Icon
          className={styles.icon}
          style={getColorStyle(
            sortConfig?.param === sortParams.CLOSED_NOT_DONE
          )}
          onClick={(e) => {
            e.stopPropagation();
            onSort({ key: 'done', param: sortParams.CLOSED_NOT_DONE });
          }}
          type="close-square"
          theme="outlined"
        />
      </Tooltip>

      <Tooltip
        mouseLeaveDelay={0}
        title="по срочности выполнения"
      >
        <span
          className={styles.icon}
          style={getColorStyle(sortConfig?.param === sortParams.URGENCY)}
          onClick={(e) => {
            e.stopPropagation();
            onSort({ key: 'done', param: sortParams.URGENCY });
          }}
        >
          A
        </span>
      </Tooltip>
    </>
  );
};

export default SortDone;
